import { useMutation } from "react-query";
import { sendTransferFundToJVA } from "../services/transferFundToJVA";

function useTransferFundToJVA(){
    return useMutation(["confirm-transfer-fund"], sendTransferFundToJVA);
}

export default useTransferFundToJVA;